import Link from 'next/link';
import { useEffect, useRef } from 'react';

import {
  ImageWithFallbackArticle,
} from '@/components/image-with-fallback-article';
import { getInternalLink } from '@/utils/url/utm';

import { THUMBNAIL_COVER_HEIGHT, THUMBNAIL_COVER_WIDTH } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Item: Component = ({
  title,
  thumbnailUrl,
  href,
  onClick,
}) => {
  const containerRootElRef = useRef<HTMLAnchorElement | null>(null);

  useEffect(() => {
    const { current: containerRootEl } = containerRootElRef;

    if (!containerRootEl) {
      return undefined;
    }

    const observer = new ResizeObserver(() => {
      const { requestAnimationFrame, cancelAnimationFrame } = window;

      const reqAnimId = requestAnimationFrame(() => {
        cancelAnimationFrame(reqAnimId);
      });
    });

    observer.observe(containerRootEl);

    return () => {
      observer.disconnect();
    };
  }, []);

  const children = (
    <>
      <ImageWithFallbackArticle
        alt={title}
        className={styles.imageItem}
        height={THUMBNAIL_COVER_HEIGHT}
        src={thumbnailUrl}
        width={THUMBNAIL_COVER_WIDTH} />
      <span className={styles.textTitle}>
        {title}
      </span>
    </>
  );
  return href
    ? (
      <Link
        ref={containerRootElRef}
        className={styles.containerRoot}
        href={getInternalLink(href, 'recommenddy')}>
        {children}
      </Link>
    )
    : (
      <button
        className={styles.containerRoot}
        onClick={onClick}>
        {children}
      </button>
    );
};
